import { render, staticRenderFns } from "./DashboardQuickActions.vue?vue&type=template&id=63c50416&scoped=true"
import script from "./DashboardQuickActions.vue?vue&type=script&lang=js"
export * from "./DashboardQuickActions.vue?vue&type=script&lang=js"
import style0 from "./DashboardQuickActions.vue?vue&type=style&index=0&id=63c50416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c50416",
  null
  
)

export default component.exports